import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

let currentYear = new Date().getFullYear();

const Footer = ({ footerLinks, siteAuthor, siteTitle }) => (
    <footer>
        <div className={"max-w-screen-xl mx-auto py-12 lg:py-16 px-6 md:px-12"}>
            <div className={"grid grid-cols-12 gap-4 items-center lg:gap-12"}>
                <div className={"col-span-12 md:col-span-6"}>
                    <p className={"mb-0 border-b border-gray-300 pb-5 text-center text-gray-700 md:text-left md:border-b-0 md:pb-0"}>
                        <small className={"text-xs xl:text-sm"}>Copyright {currentYear} {siteTitle} Limited. All rights reserved. Web Design by <a href="https://www.enovate.co.uk" target="_blank" rel="noopener noreferrer" className={"inline"}>{siteAuthor}</a>.</small>
                    </p>
                </div>

                <div className={"col-span-12 md:col-span-6"}>
                    <nav>
                        <ul className={"flex flex-wrap flex-row justify-center md:justify-end"}>
                            {footerLinks.map(link => (
                                <li key={link.title} className={"text-center"}>
                                    <Link to={link.path} className={"mx-2 mb-1 text-gray-700 text-xs sm:mb-0 md:ml-5 md:mr-0 xl:text-sm"}>
                                        {link.title}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </footer>
)

Footer.propTypes = {
    siteAuthor: PropTypes.string,
    siteTitle: PropTypes.string,
}

export default Footer
